export default __webpack_public_path__ + "static/media/subaru.5a3b0549.svg";